import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_INVOICES_REFRESH: createSagaAction('JOB_INVOICES_REFRESH'),

  JOB_INVOICE_CREATE: createSagaAction('JOB_INVOICE_CREATE'),
  JOB_INVOICE_UPDATE: createSagaAction('JOB_INVOICE_UPDATE'),
  JOB_INVOICE_DELETE: createSagaAction('JOB_INVOICE_DELETE'),

  UPLOAD_INVOICE_ATTACHMENT: createSagaAction('UPLOAD_INVOICE_ATTACHMENT'),
  GET_INVOICE_ATTACHMENTS: createSagaAction('GET_INVOICE_ATTACHMENTS'),
  UPDATE_INVOICE_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_INVOICE_ATTACHMENT_DESCRIPTION'),
  DELETE_INVOICE_ATTACHMENT: createSagaAction('DELETE_INVOICE_ATTACHMENT')
}

// Action Creators
export const actions = {
  jobInvoicesRefresh: ({ jobId, assignedToId, fromDashboard, next }) => ({
    type: constants.JOB_INVOICES_REFRESH.ACTION,
    jobId,
    assignedToId,
    fromDashboard,
    next
  }),

  createJobInvoice: ({ jobId, content, userId }) => ({
    type: constants.JOB_INVOICE_CREATE.ACTION,
    jobId,
    content,
    userId
  }),

  updateJobInvoice: ({ jobId, invoiceId, userId, content }) => ({
    type: constants.JOB_INVOICE_UPDATE.ACTION,
    jobId,
    invoiceId,
    userId,
    content
  }),

  deleteJobInvoice: ({ invoiceId, jobId }) => ({
    type: constants.JOB_INVOICE_DELETE.ACTION,
    jobId,
    invoiceId
  }),

  // Attachment actions
  uploadInvoiceAttachment: ({ formData, invoiceId }) => ({
    type: constants.UPLOAD_INVOICE_ATTACHMENT.ACTION,
    formData,
    invoiceId
  }),

  getInvoiceAttachments: ({ invoiceId }) => ({
    type: constants.GET_INVOICE_ATTACHMENTS.ACTION,
    invoiceId
  }),

  updateInvoiceAttachmentDescription: ({ attachmentId, invoiceId, description, userId }) => ({
    type: constants.UPDATE_INVOICE_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    invoiceId,
    description,
    userId
  }),

  deleteInvoiceAttachment: ({ attachmentId, invoiceId }) => ({
    type: constants.DELETE_INVOICE_ATTACHMENT.ACTION,
    attachmentId,
    invoiceId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_INVOICES_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_INVOICES_REFRESH.SUCCESS:
      return {
        ...state,
        jobInvoices: action.payload
      }
    case constants.JOB_INVOICES_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_INVOICE_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_INVOICE_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_INVOICE_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_INVOICE_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_INVOICE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_INVOICE_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_INVOICE_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        invoiceAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_INVOICE_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_INVOICE_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_INVOICE_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobInvoiceActions.js